var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoupe = function SvgLoupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm6.872-1.688a9 9 0 1 0-1.06 1.06l4.908 4.908a.75.75 0 1 0 1.06-1.06l-4.908-4.908Z",
    fill: "#000"
  })));
};
export default SvgLoupe;